import React from "react";
import { motion } from "framer-motion";
import { formatDate, formatDateShort, getStatusColor, getStatusText, getEnrollmentType, getDocumentStatusIcon } from "./helpers";

const SubmissionsTable = ({
    submissions,
    canApproveFeeSchedule,
    approvingFeeSchedule,
    onViewDetails,
    onViewDocuments,
    onOpenActivity,
    onDelete,
    onFeeScheduleApproval,
}) => (
    <div className="submissions-table-container">
        <table className="submissions-table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Practice</th>
                    <th>Email</th>
                    <th>Specialty</th>
                    <th>Location</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Docs</th>
                    <th>Contact Log</th>
                    <th>Submitted</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {submissions.map((submission) => (
                    <motion.tr
                        key={submission.id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="submission-row">
                        <td>{submission.name || "N/A"}</td>
                        <td
                            className="practice-name-cell"
                            onClick={() => onViewDetails(submission)}
                            title={submission.practiceName ? "Click to view details" : "No practice name — click to add"}
                        >{submission.practiceName || "—"}</td>
                        <td>{submission.email || "N/A"}</td>
                        <td className="specialty-cell">
                            <span className={`specialty-badge specialty-${submission.specialty}`}>{submission.specialty || "N/A"}</span>
                        </td>
                        <td>{submission.location || "N/A"}</td>
                        <td>
                            <span
                                className={`enrollment-badge enrollment-${getEnrollmentType(submission)}`}
                                title={getEnrollmentType(submission) === "paper" ? "Manually registered — signed a paper contract" : "Signed up through the website"}>
                                {getEnrollmentType(submission) === "paper" ? "📄 Paper" : "🌐 Online"}
                            </span>
                        </td>
                        <td>
                            <span className={`status-badge status-${getStatusColor(submission)}`}>{getStatusText(submission)}</span>
                            {submission.status === "email_failed" && (
                                <span
                                    className="email-failed-flag"
                                    title={`Automated email failed${submission.emailError ? `: ${submission.emailError}` : ""}.${getEnrollmentType(submission) === "paper" ? " Open the Contact Log checklist to resend the intro email." : ""}`}>
                                    ⚠️
                                </span>
                            )}
                        </td>
                        <td className="docs-cell">
                            <button
                                className="docs-btn"
                                onClick={() => onViewDocuments(submission)}
                                title="View Documents">
                                {getDocumentStatusIcon(submission)}
                            </button>
                        </td>
                        <td className="notes-cell">
                            <button
                                className="activity-btn"
                                onClick={() => onOpenActivity(submission)}
                                title={submission.activityLog?.length ? `${submission.activityLog.length} activity entries` : "Add notes"}
                            >
                                {submission.activityLog?.length > 0 ? (
                                    <span className="notes-indicator">
                                        📋 <span className="activity-count">{submission.activityLog.length}</span>
                                    </span>
                                ) : (
                                    <span className="no-notes-indicator">＋</span>
                                )}
                            </button>
                        </td>
                        <td className="submitted-cell">{formatDateShort(submission.timestamp)}</td>
                        <td className="actions-cell">
                            <button
                                className="view-btn"
                                onClick={() => onViewDetails(submission)}>
                                View
                            </button>
                            <button
                                className="delete-btn"
                                onClick={() => onDelete(submission)}
                                title="Delete Application">
                                🗑️
                            </button>
                            {/* Fee Schedule Approval - checkbox for authorized users, status badge for others */}
                            <div className="fee-schedule-approval" title={
                                submission.feeScheduleApproved
                                    ? `Approved by ${submission.feeScheduleApprovedByName || 'Admin'} on ${formatDate(submission.feeScheduleApprovedAt)}`
                                    : canApproveFeeSchedule ? 'Click to approve fee schedule' : 'Pending approval'
                            }>
                                {canApproveFeeSchedule ? (
                                    <label className="fee-checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={submission.feeScheduleApproved || false}
                                            onChange={(e) => onFeeScheduleApproval(submission, e.target.checked)}
                                            disabled={approvingFeeSchedule === submission.id}
                                        />
                                        <span className="fee-checkbox-text">
                                            {approvingFeeSchedule === submission.id ? '...' : 'Fee ✓'}
                                        </span>
                                    </label>
                                ) : (
                                    <span className={`fee-status-badge ${submission.feeScheduleApproved ? 'approved' : 'pending'}`}>
                                        {submission.feeScheduleApproved ? '✓ Fee' : '○ Fee'}
                                    </span>
                                )}
                            </div>
                        </td>
                    </motion.tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default SubmissionsTable;
